module.exports = __webpack_public_path__ + "img/question14c1.c6377059.png";